/**
 * @file   : Advertise.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/11/2019, 11:11:17 AM
 */
import PropTypes from 'prop-types'
import React from 'react'

import AButtonStandard from '../../external/components/button/AButtonStandard'
import BoxContainer from '../../external/components/container/BoxContainer'
import DynamicDataCmp from '../../external/components/form/dynamicData/DynamicDataCmp'
import { ALIGN_CENTER } from '../../external/components/layout/Cont'
import Cont from '../../external/components/layout/Cont'
import Section from '../../external/components/layout/Section'
import AIconAction from '../../external/components/link/AIconAction'
import { createSimpleLinkProps } from '../../external/components/link/LinkUtils'
import TextHoverable from '../../external/components/link/TextHoverable'
import TextStyler, {
  FONT_SIZE,
  GREY_TEXT,
} from '../../external/components/text/TextStyler'
import { isEmpty } from '../../external/utilities/GeneralUtils'
import { getHomeRoute } from '../../router/RouteManager'
import { getAdConfig } from '../../utilities/ConfigUtils'
import { simpleTranslate } from '../Translation'
import ErrorBlock from '../shared/ErrorBlock'
import Advert from '../shared/ad/Advert'
import SimplePageHero from '../shared/header/SimplePageHero'
import PageBase from '../sharedInternal/container/page/PageBase'
import PageContent from '../sharedInternal/container/page/PageContent'
import { MODE_COMPLETE } from './AdvertiseContainer'

const AdvertiseLayout = ({
  theme,
  intl,
  errors,
  inquiry,
  validationRquestId,
  mode,
  onValidationRequest,
  onValidation,
  mainConfig,
}) => {
  const getHeroUI = function () {
    const titleText = simpleTranslate(intl, 'advertise_page_title', '')
    const taglineText = simpleTranslate(intl, 'advertise_page_tagline', '')

    return (
      <SimplePageHero
        imageURL={'/newra/assets/images/ra/advert_hero.jpg'}
        titleText={titleText}
        taglineText={taglineText}
      />
    )
  }

  const getDescriptionUI = function () {
    if (mode === MODE_COMPLETE) {
      return null
    }

    return (
      <Cont>
        <BoxContainer borderColor={'grey'}>
          <Cont>
            <TextStyler
              styleObj={{
                ...GREY_TEXT,
                fontSize: FONT_SIZE.X4,
              }}
            >
              {simpleTranslate(intl, 'advertise_description', '')}
            </TextStyler>
          </Cont>
        </BoxContainer>
        <Section />
      </Cont>
    )
  }

  const getMainUI = function () {
    if (mode === MODE_COMPLETE) {
      return (
        <BoxContainer borderColor={'grey'}>
          <Cont>
            <Cont>
              <TextHoverable
                fontSizeType={2}
                fontFamily={'Georgia'}
                fontColor={'grey'}
                selected
              >
                {simpleTranslate(intl, 'advertise_inquiry_success_head', '')}
              </TextHoverable>
            </Cont>
            <Section />
            {simpleTranslate(intl, 'advertise_inquiry_success', '')}
          </Cont>
          <Section />
          <Cont>
            <AIconAction
              label={simpleTranslate(intl, 'HOME', '')}
              faStyle={'fa-arrow-left'}
              isShowAsLink
              {...createSimpleLinkProps(getHomeRoute(), true, false)}
            />
            <Section />
          </Cont>
        </BoxContainer>
      )
    }

    return (
      <Cont>
        <ErrorBlock errors={errors} intl={intl} />
        <DynamicDataCmp
          intlObj={intl}
          data={inquiry.inquiryData}
          validationRequestId={validationRquestId}
          onValidation={onValidation}
        />

        <AButtonStandard
          onClick={onValidationRequest}
          cmpRef={'advertise-inquiry-submit-button'}
          usePadding={false}
        >
          {simpleTranslate(intl, 'labels_generic_submit', '')}
        </AButtonStandard>
      </Cont>
    )
  }

  const getFooterUI = function () {
    if (isEmpty(mainConfig)) {
      return null
    }

    return (
      <Cont align={ALIGN_CENTER}>
        <Advert id={'HP8'} adConfig={getAdConfig(mainConfig)} />
        <Section />
      </Cont>
    )
  }

  if (isEmpty(inquiry)) {
    return <Cont></Cont>
  }

  return (
    <PageBase showGenericBG>
      {getHeroUI()}
      <PageContent noHeader>
        {getDescriptionUI()}
        {getMainUI()}
        <Section />
        {getFooterUI()}
      </PageContent>
    </PageBase>
  )
}

AdvertiseLayout.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  inquiry: PropTypes.object.isRequired,
  validationRquestId: PropTypes.number.isRequired,
  mode: PropTypes.string.isRequired,
  onValidationRequest: PropTypes.func.isRequired,
  onValidation: PropTypes.func.isRequired,
  mainConfig: PropTypes.object.isRequired,
}

export default AdvertiseLayout
